<template>
  <div class="xuewei-item-container">
    <custom-router-link :item="info" class="xuewei-link" :to="{name: 'XueweiDetails', params: {id: info.id}}" target="_blank">
      <div class="news-title">{{info.name}}</div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.xuewei-item-container {
  height: 40px;
  .xuewei-link {
    width: 100%;
    height: 100%;
    position: relative;
    &:hover {
      background: #f8f9fa;
      .news-title {
        color: #fff;
        background: #2960a7;
      }
    }
    .news-title {
      width: 100%;
      height: 100%;
      padding: 0 20px;
      font-size: 16px;
      line-height: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333;
      background: #f1f1f1;
    }
  }
}

@media screen and (max-width: 768px) {
  .xuewei-item-container {
    height: 40px;
    .xuewei-link {
      .news-title {
        font-size: 14px;
      }
    }
  }
}
</style>